module.exports = __webpack_public_path__ + "static/media/17.a437e1bc.jpg";